import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
	findUser({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`user/findUser`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  save({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`user/save`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findById({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`user/findById`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findCurrentUserOrgInfo({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`user/findCurrentUserOrgInfo`)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  deactivateUser({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`user/deactivateUser`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  distributionOrg({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`user/distributionOrg`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  batchRecovery({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`user/batchRecovery`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  recoveryUser({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`user/recoveryUser`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  restPassword({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`user/restPassword`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  deleteUser({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`user/deleteUser`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  batchDelete({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`user/batchDelete`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  batchDeactivateUser({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`user/batchDeactivateUser`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  batchRestPassword({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`user/batchRestPassword`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findUserByOrgId({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`user/findUserByOrgId`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
  getParentProvince({ commit }, params) {
	return new Promise((resolve, reject) => {
		axios.get(`user/getParentProvince`, {params})
			.then(response => {
				resolve(response)
			})
			.catch(error => {
				reject(error)
			})
	})
	},
  
	findUserIsAdmin({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`user/findUserIsAdmin`)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  	},
  
}
